import {
  ADD_NEWLETTER,
  NEWLETTER,
  DELETE_NEWLETTER,
  NEWLETTER_DETAIL,
  EDIT_NEWLETTER,
} from "../actions/Actions";

const initalState = {
  listLoader: false,
  listCount: null,
  list: [],
  addLoader: false,
  deleteLoader: false,
  detailLoader: false,
  detail: null,
  editLoader: false,
};

export function newsletterReducer(state = initalState, action) {
  const { type, payload } = action;

  switch (type) {
    // GET
    case NEWLETTER.LOADING:
      return {
        ...state,
        listLoader: true,
      };
    case NEWLETTER.SUCCESS:
      return {
        ...state,
        listLoader: false,
        listCount: payload.total,
        list: payload.rows,
      };
    case NEWLETTER.ERROR:
      return {
        ...state,
        listLoader: false,
      };

    // GET DETAIL
    case NEWLETTER_DETAIL.LOADING:
      return {
        ...state,
        detailLoader: true,
        detail: null,
      };
    case NEWLETTER_DETAIL.SUCCESS:
      return {
        ...state,
        detailLoader: false,
        detail: payload,
      };
    case NEWLETTER_DETAIL.ERROR:
      return {
        ...state,
        detailLoader: false,
      };

    //  ADD
    case ADD_NEWLETTER.LOADING:
      return {
        ...state,
        addLoader: true,
      };
    case ADD_NEWLETTER.SUCCESS:
      return {
        ...state,
        addLoader: false,
      };
    case ADD_NEWLETTER.ERROR:
      return {
        ...state,
        addLoader: false,
      };

    //  edit
    case EDIT_NEWLETTER.LOADING:
      return {
        ...state,
        editLoader: true,
      };
    case EDIT_NEWLETTER.SUCCESS:
      return {
        ...state,
        editLoader: false,
      };
    case EDIT_NEWLETTER.ERROR:
      return {
        ...state,
        editLoader: false,
      };

    // DELETE
    case DELETE_NEWLETTER.LOADING:
      return {
        ...state,
        deleteLoader: true,
      };
    case DELETE_NEWLETTER.SUCCESS:
      return {
        ...state,
        deleteLoader: false,
      };
    case DELETE_NEWLETTER.ERROR:
      return {
        ...state,
        deleteLoader: false,
      };

    default:
      return state;
  }
}
